import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	_STATE_CAMPUS_LOCATIONS_FEATURE_KEY,
	CampusLocationsState,
} from './campus-locations.reducer';

// Lookup the 'StateCampusLocations' feature state managed by NgRx
export const getCampusLocationsState = createFeatureSelector<CampusLocationsState>(
	_STATE_CAMPUS_LOCATIONS_FEATURE_KEY,
);

export const getStateCampusLocationsLoaded = createSelector(
	getCampusLocationsState,
	(state: CampusLocationsState) => state.loaded,
);

export const getStateCampusLocationsError = createSelector(
	getCampusLocationsState,
	(state: CampusLocationsState) => state.error,
);

export const getStateCampusLocations = createSelector(
	getCampusLocationsState,
	(state: CampusLocationsState) => {
		return state.campus;
	},
);

export const getStateCampusLocationsUniversityUrl = createSelector(
	getCampusLocationsState,
	(state: CampusLocationsState) => state.selectedUniversityUrl,
);
